import {getActiveLanguage, trans, wTrans} from "laravel-vue-i18n";

export const mainCategories = ['games', 'subscriptions'];
export const getChooseAll = () => ({id: 0, title: trans('All categories'), slug: 'products'})

export const getArrSortsReview = () => ([
        {title: wTrans('All feedbacks'), val: undefined},
        {title: undefined, val: 5},
        {title: undefined, val: 4},
        {title: undefined, val: 3},
        {title: undefined, val: 2},
        {title: undefined, val: 1}
    ]
)

/**
 * Mirrors App\Enums\Locale - the values arrive from the backend as the `lang` Inertia prop.
 * `hi` is configured as a UI locale but carries no content, so nothing branches on it.
 */
export const LOCALES = {
    RU: 'ru',
    EN: 'en',
}

export const getLangs = () => {
    return [
        {code: LOCALES.RU, name: 'Русский', short: trans('RUS')},
        {code: LOCALES.EN, name: 'English', short: 'ENG'}
    ];
}

export const getLang = () => {
    const activeLang = getActiveLanguage()
    return getLangs().find(item => item.code === activeLang)
}

export const getCurrencies = () => [{code: 'RUB', name: 'Руб.', symbol: '₽'}, {code: 'USD', name: 'USD', symbol: '$'}]
export const HelpDeskUrl = 'https://anykod.freshdesk.com/support/home'
export const tgSupportUrl = 'https://t.me/anykod_support_bot'
export const tgSupportUrlEn = 'https://t.me/anykod_support_en_bot'
export const tgRbxSupportBot = 'https://t.me/rbx_anykod_support_bot'
export const tgUrl = 'https://t.me/anykod'
export const vkUrl = 'https://vk.com/anykod'
export const HelpDeskNewTicket = 'https://anykod.freshdesk.com/support/tickets/new'
export const myWotUrl = 'https://www.mywot.com/scorecard/anykod.com'
export const trustpilotUrl = 'https://www.trustpilot.com/review/anykod.com'

export const CURRENCIES = {
    RUB: 'rub',
    USD: 'usd',
}

export const robloxBuyers = [
    {"username": "abo...an", "robuxes": 20},
    {"username": "kri...33", "robuxes": 1350},
    {"username": "sav...88", "robuxes": 200},
    {"username": "Use...86", "robuxes": 197},
    {"username": "UNU...72", "robuxes": 500},
    {"username": "cLv...30", "robuxes": 1500},
    {"username": "kaz...32", "robuxes": 800},
    {"username": "Ext...ee", "robuxes": 40},
    {"username": "OLg...95", "robuxes": 400},
    {"username": "sof...e1", "robuxes": 80},
    {"username": "Pik...00", "robuxes": 500},
    {"username": "Bog...i0", "robuxes": 1000},
    {"username": "pas...rk", "robuxes": 90},
    {"username": "BYX...26", "robuxes": 190},
    {"username": "POH...24", "robuxes": 200},
    {"username": "sta...ky", "robuxes": 1535},
    {"username": "sta...70", "robuxes": 140},
    {"username": "Mis...09", "robuxes": 2400},
    {"username": "zxc...aa", "robuxes": 300},
    {"username": "Bgx...hh", "robuxes": 700},
    {"username": "mim...a8", "robuxes": 2000},
    {"username": "h45...54", "robuxes": 500},
    {"username": "kar...uk", "robuxes": 800},
    {"username": "Rob...ar", "robuxes": 500},
    {"username": "Asd...er", "robuxes": 1000},
    {"username": "R45...45", "robuxes": 1000},
    {"username": "iam...0L", "robuxes": 535},
    {"username": "xLo...ax", "robuxes": 501},
    {"username": "BLa...me", "robuxes": 1058},
    {"username": "yaL...xx", "robuxes": 500},
    {"username": "MC_...ON", "robuxes": 500},
    {"username": "bab...ay", "robuxes": 1350},
    {"username": "poo...q2", "robuxes": 30},
    {"username": "za4...Lp", "robuxes": 189},
    {"username": "cwd...06", "robuxes": 350},
    {"username": "Rai...ei", "robuxes": 40},
    {"username": "kwu...au", "robuxes": 500},
    {"username": "22g...a5", "robuxes": 60},
    {"username": "piz...sa", "robuxes": 120},
    {"username": "FAK...0M", "robuxes": 1263},
    {"username": "iDO...Ri", "robuxes": 1500},
    {"username": "Bam...24", "robuxes": 1128},
    {"username": "DRA...22", "robuxes": 1350},
    {"username": "Art...bL", "robuxes": 1000},
    {"username": "iju...yu", "robuxes": 1100},
    {"username": "Lak..._q", "robuxes": 848},
    {"username": "1z1...07", "robuxes": 722},
    {"username": "Dev...88", "robuxes": 693},
    {"username": "rer...yt", "robuxes": 1554},
    {"username": "mrA...D0", "robuxes": 1429},
    {"username": "XaL...va", "robuxes": 247},
    {"username": "Rei...24", "robuxes": 1200},
    {"username": "Day...si", "robuxes": 50},
    {"username": "a_p...oo", "robuxes": 182},
    {"username": "3ra...73", "robuxes": 543},
    {"username": "kst...34", "robuxes": 1500},
    {"username": "12L...31", "robuxes": 796},
    {"username": "Rom...ro", "robuxes": 80},
    {"username": "ALy...p1", "robuxes": 400},
    {"username": "sjs...o2", "robuxes": 92},
    {"username": "tva...72", "robuxes": 475},
    {"username": "bob...vi", "robuxes": 1000},
    {"username": "MR_...K1", "robuxes": 80},
    {"username": "you...xX", "robuxes": 180},
    {"username": "Gas...pG", "robuxes": 218},
    {"username": "Hma...rH", "robuxes": 1492},
    {"username": "KEN...EK", "robuxes": 160},
    {"username": "seb...iv", "robuxes": 500},
    {"username": "Zen...y3", "robuxes": 700},
    {"username": "Vuk...33", "robuxes": 734},
    {"username": "Sah...in", "robuxes": 2045},
    {"username": "ALe...1f", "robuxes": 512},
    {"username": "cok...r2", "robuxes": 800},
    {"username": "Yus...yh", "robuxes": 500},
    {"username": "wol...38", "robuxes": 1017},
    {"username": "ArT...al", "robuxes": 900},
    {"username": "Sun...rr", "robuxes": 560},
    {"username": "hro...a7", "robuxes": 500},
    {"username": "isL...tf", "robuxes": 1100},
    {"username": "dop...82", "robuxes": 464},
    {"username": "sup...56", "robuxes": 600},
    {"username": "kr1...77", "robuxes": 1380},
    {"username": "mop...ps", "robuxes": 28},
    {"username": "Dan...54", "robuxes": 200},
    {"username": "Zeb...Ne", "robuxes": 65},
    {"username": "sti...ki", "robuxes": 44},
    {"username": "Mas...66", "robuxes": 500},
    {"username": "0oL...o0", "robuxes": 500},
    {"username": "rRy...GF", "robuxes": 142},
    {"username": "Dhs...gd", "robuxes": 1200},
    {"username": "WoL...ie", "robuxes": 300},
    {"username": "Sas...12", "robuxes": 1157},
    {"username": "HiF...16", "robuxes": 1319},
    {"username": "e62...to", "robuxes": 1000},
    {"username": "das...ss", "robuxes": 900},
    {"username": "LoL...it", "robuxes": 1000},
    {"username": "Bea...LL", "robuxes": 750},
    {"username": "Dok...ze", "robuxes": 600},
    {"username": "sas...ka", "robuxes": 2500},
    {"username": "KaR...61", "robuxes": 1400},
    {"username": "Lin...68", "robuxes": 30},
    {"username": "diz...ev", "robuxes": 210},
    {"username": "Jor...26", "robuxes": 450},
    {"username": "Sav...0Y", "robuxes": 1700}
]

